import { keyframes, mergeStyles } from '@fluentui/react';

const registerFabricUtilities = (): void => {
  const fadeIn = keyframes({
    from: { opacity: 0 },
    to: { opacity: 1 },
  });
  const fadeOut = keyframes({
    from: { opacity: 1 },
    to: { opacity: 0 },
  });
  const slideUpIn = keyframes({
    from: { transform: 'translate3d(0, 48px, 0)' },
    to: { transform: 'translate3d(0, 0, 0)' },
  });
  const slideUpOut = keyframes({
    from: { transform: 'translate3d(0, 0, 0)' },
    to: { transform: 'translate3d(0, -48px, 0)' },
  });

  mergeStyles({
    selectors: {
      ':global(.ms-motion-slideUpIn)': {
        animation: `${slideUpIn} 0.1s cubic-bezier(0.1, 0.9, 0.2, 1) both, ${fadeIn} 0.1s cubic-bezier(0, 0, 1, 1) both`,
      },
      ':global(.ms-motion-slideUpOut)': {
        animation: `${slideUpOut} 0.1s cubic-bezier(0.9, 0.1, 1, 0.2) both, ${fadeOut} 0.1s cubic-bezier(0, 0, 1, 1) both`,
      },
      ':global(.ms-depth-4)': {
        boxShadow: '0 1.6px 3.6px 0 rgba(0, 0, 0, 0.132), 0 0.3px 0.9px 0 rgba(0, 0, 0, 0.108)',
      },
      ':global(.ms-depth-8)': {
        boxShadow: '0 3.2px 7.2px 0 rgba(0, 0, 0, 0.132), 0 0.6px 1.8px 0 rgba(0, 0, 0, 0.108)',
      },
      ':global(.ms-Grid)': {
        boxSizing: 'border-box',
        padding: '0 8px',
        zoom: 1,
      },
      ':global(.ms-Grid::before), :global(.ms-Grid::after)': {
        display: 'table',
        content: "''",
        lineHeight: 0,
      },
      ':global(.ms-Grid::after)': {
        clear: 'both',
      },
      ':global(.ms-Grid-row)': {
        boxSizing: 'border-box',
        margin: '0 -8px',
        zoom: 1,
      },
      ':global(.ms-Grid-row::before), :global(.ms-Grid-row::after)': {
        display: 'table',
        content: "''",
        lineHeight: 0,
      },
      ':global(.ms-Grid-row::after)': {
        clear: 'both',
      },
      ':global(.ms-Grid-col)': {
        position: 'relative',
        boxSizing: 'border-box',
        minHeight: '1px',
        paddingRight: '8px',
        paddingLeft: '8px',
      },
      ":global([dir='ltr'] .ms-Grid-col)": {
        float: 'left',
      },
      ":global([dir='rtl'] .ms-Grid-col)": {
        float: 'right',
      },
      ':global(.ms-Grid-col .ms-Grid)': {
        padding: 0,
      },
      ':global(.ms-sm11)': {
        width: '91.6666666667%',
      },
      ':global(.ms-Fabric)': {
        color: '#323130',
        fontFamily:
          "'Segoe UI', -apple-system, BlinkMacSystemFont, Roboto, 'Helvetica Neue', sans-serif",
        fontSize: '14px',
        MozOsxFontSmoothing: 'grayscale',
        WebkitFontSmoothing: 'antialiased',
      },
      ':global(.ms-Fabric button), :global(.ms-Fabric input), :global(.ms-Fabric textarea)': {
        fontFamily: 'inherit',
      },
      ':global(.ms-hiddenMdDown)': {
        '@media (max-width: 639.99999px)': {
          display: 'none !important',
        },
      },
      ':global(.ms-hiddenLgDown)': {
        '@media (max-width: 1023.99999px)': {
          display: 'none !important',
        },
      },
      ':global(.ms-hiddenLgUp)': {
        '@media (min-width: 640px)': {
          display: 'none !important',
        },
      },
      ':global(.ms-xl8)': {
        '@media (min-width: 1024px)': {
          width: '66.6666666667%',
        },
      },
      ':global(.ms-hiddenXlUp)': {
        '@media (min-width: 1024px)': {
          display: 'none !important',
        },
      },
      ':global(.ms-xxl6)': {
        '@media (min-width: 1366px)': {
          width: '50%',
        },
      },
      ':global(.ms-xxxl6)': {
        '@media (min-width: 1920px)': {
          width: '50%',
        },
      },
    },
  });
};

export default registerFabricUtilities;
